<template>
<v-layout align-start>


 

<v-container >
<v-row
      class="mb-6"
      no-gutters
    >
      <v-col
        sm="4"
        md="4"
      >        
                    <v-card
                    class="mx-auto"
                    color="#FA8072"
                    dark
                    max-width="400"
                >
                    <v-card-title>
                    <v-icon
                        large
                        left
                    >
                        mdi-twitter
                    </v-icon>
                    <span class="title font-weight-light">ME Engineer</span>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                    All projects Rejected.
                    </v-card-text>

                    <v-card-actions>
                    
                    <v-list-item class="grow">                

                        <v-list-item-content>
                        <v-list-item-title> 
                        <v-btn class="ma-2"  fab color="primary"
                         @click="showDashboardDetail(6)"
                        >
                                <v-icon>list</v-icon>
                         </v-btn>
                        </v-list-item-title>
                        </v-list-item-content>
                        <v-row
                        align="center"
                        justify="end"
                        >
                        <v-icon class="mr-1">mdi-heart</v-icon>
                        <span class="subheading mr-2"><h1>{{dashboardRejected6.length}}</h1></span>                
                        </v-row>
                    </v-list-item>            
                    
                
                    </v-card-actions>
                </v-card>
            
      </v-col>
      <v-col
        sm="4"        
        md="4"        
      >
       <v-card
                    class="mx-auto"
                    color="#D6D5D5"                    
                    max-width="400"
                >
                    <v-card-title>
                    <v-icon
                        large
                        left
                    >
                        mdi-twitter
                    </v-icon>
                    <span class="title font-weight-light">ME Engineer</span>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                    All projects under development.
                    </v-card-text>

                    <v-card-actions>
                    
                    <v-list-item class="grow">                

                        <v-list-item-content>
                        <v-list-item-title> 
                        <v-btn class="ma-2"  fab color="primary"
                         @click="showDashboardDetail(1)"
                        >
                                <v-icon>list</v-icon>
                         </v-btn>
                        </v-list-item-title>
                        </v-list-item-content>
                        <v-row
                        align="center"
                        justify="end"
                        >
                        <v-icon class="mr-1">mdi-heart</v-icon>
                        <span class="subheading mr-2"><h1>{{dashboardDevelopment1.length}}</h1></span>                
                        </v-row>
                    </v-list-item>            
                    
                
                    </v-card-actions>
                </v-card>
            
      </v-col>
       <v-col
        sm="4"        
        md="4"        
      >
       <v-card
                    class="mx-auto"
                    color="#EAF9B3"
                    
                    max-width="400"
                >
                    <v-card-title>
                    <v-icon
                        large
                        left
                    >
                        mdi-twitter
                    </v-icon>
                    <span class="title font-weight-light">Production</span>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                    All projects Approved.
                    </v-card-text>

                    <v-card-actions>
                    
                    <v-list-item class="grow">                

                        <v-list-item-content>
                        <v-list-item-title> 
                         <v-btn class="ma-2"  fab color="primary"
                          @click="showDashboardDetail(4)"
                         >
                                <v-icon>list</v-icon>
                         </v-btn>
                        </v-list-item-title>
                        </v-list-item-content>
                        <v-row
                        align="center"
                        justify="end"
                        >
                        <v-icon class="mr-1">mdi-heart</v-icon>
                        <span class="subheading mr-2"><h1>{{dashboardApproved4.length}}</h1></span>                
                        </v-row>
                    </v-list-item>            
                    
                
                    </v-card-actions>
                </v-card>
            
      </v-col>
    
    </v-row>
   <v-row
      class="mb-6"
      no-gutters
    >
      <v-col
        sm="4"
        md="4"
      >        
                    <v-card
                    class="mx-auto"
                    color="#CD5C5C"
                    dark
                    max-width="400"
                >
                    <v-card-title>
                    <v-icon
                        large
                        left
                    >
                        mdi-twitter
                    </v-icon>
                    <span class="title font-weight-light">ME Engineer</span>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                    All projects Canceled.
                    </v-card-text>

                    <v-card-actions>
                    
                    <v-list-item class="grow">                

                        <v-list-item-content>
                        <v-list-item-title> 
                         <v-btn class="ma-2"  fab color="primary"
                          @click="showDashboardDetail(7)"
                         >
                                <v-icon>list</v-icon>
                         </v-btn>
                        </v-list-item-title>
                        </v-list-item-content>
                        <v-row
                        align="center"
                        justify="end"
                        >
                        <v-icon class="mr-1">mdi-heart</v-icon>
                        <span class="subheading mr-2"><h1>{{dashboardCanceled7.length}}</h1></span>                
                        </v-row>
                    </v-list-item>            
                    
                
                    </v-card-actions>
                </v-card>
            
      </v-col>
      <v-col
        sm="4"        
        md="4"        
      >
       <v-card
                    class="mx-auto"
                    color="#AEAEAE"
                    dark
                    max-width="400"
                >
                    <v-card-title>
                    <v-icon
                        large
                        left
                    >
                        mdi-twitter
                    </v-icon>
                    <span class="title font-weight-light">ME Engineer</span>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                    All projects under Validating.
                    </v-card-text>

                    <v-card-actions>
                    
                    <v-list-item class="grow">                

                        <v-list-item-content>
                        <v-list-item-title>
                         <v-btn class="ma-2"  fab color="primary"
                          @click="showDashboardDetail(2)"
                         >
                                <v-icon>list</v-icon>
                         </v-btn>
                         </v-list-item-title>
                        </v-list-item-content>
                        <v-row
                        align="center"
                        justify="end"
                        >
                        <v-icon class="mr-1">mdi-heart</v-icon>
                        <span class="subheading mr-2"><h1>{{ dashboardValidating2.length}}</h1></span>                
                        </v-row>
                    </v-list-item>            
                    
                
                    </v-card-actions>
                </v-card>
            
      </v-col>
       <v-col
        sm="4"        
        md="4"        
      >
       <v-card
                    class="mx-auto"
                    color="#D6FB4F"                    
                    max-width="400"
                >
                    <v-card-title>
                    <v-icon
                        large
                        left
                    >
                        mdi-twitter
                    </v-icon>
                    <span class="title font-weight-light">Production</span>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                    All projects Promoted.
                    </v-card-text>

                    <v-card-actions>
                    
                    <v-list-item class="grow">                

                        <v-list-item-content>
                        <v-list-item-title>                         
                      
                            <v-btn class="ma-2"  fab color="primary"
                             @click="showDashboardDetail(5)"
                            >
                                <v-icon>list</v-icon>
                            </v-btn>

                        </v-list-item-title>
                        </v-list-item-content>
                        <v-row
                        align="center"
                        justify="end"
                        >
                        <v-icon class="mr-1">mdi-heart</v-icon>
                        <span class="subheading mr-2"><h1>{{dashboardPromoted5.length}}</h1></span>                
                        </v-row>
                    </v-list-item>            
                    
                
                    </v-card-actions>
                </v-card>
            
      </v-col>
    
    </v-row>

    <v-row
      class="mb-6"
      no-gutters
    >
      <v-col
        sm="4"
        md="4"
      >       
         
            
      </v-col>
      <v-col
        sm="4"        
        md="4"        
      >
       <v-card
                    class="mx-auto"
                    color="#696868"
                    dark
                    max-width="400"
                >
                    <v-card-title>
                    <v-icon
                        large
                        left
                    >
                        mdi-twitter
                    </v-icon>
                    <span class="title font-weight-light">ME Engineer</span>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                    All projects under Approving.
                    </v-card-text>

                    <v-card-actions>
                    
                    <v-list-item class="grow">                

                        <v-list-item-content>
                        <v-list-item-title> 
                         <v-btn class="ma-2"  fab color="primary"
                          @click="showDashboardDetail(3)"
                         >
                                <v-icon>list</v-icon>
                            </v-btn>
                        </v-list-item-title>
                        </v-list-item-content>
                        <v-row
                        align="center"
                        justify="end"
                        >
                        <v-icon class="mr-1">mdi-heart</v-icon>
                        <span class="subheading mr-2"><h1>{{dashboardApproving3.length}}</h1></span>                
                        </v-row>
                    </v-list-item>            
                    
                
                    </v-card-actions>
                </v-card>
            
      </v-col>
       <v-col
        sm="4"        
        md="4"        
      >
      
            
      </v-col>
    
    </v-row>


    <v-row>
                        <v-dialog v-model="dialogShowDashboardDetail" persistent max-width="1300px"   >
                            <v-card>
                            <v-toolbar
                                color="indigo"
                                dark
                                >                              
                                <v-toolbar-title>{{title}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon @click="hideDashboardDetail">close</v-icon>
                                </v-btn>
                                </v-toolbar>                                                
                                <v-card-text>

                                    <v-container  grid-list-sm class="pa-4 white" >              
                                        <v-layout row wrap>                
                                        
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                          
                                            <!--DataTable here-->
                                         <v-data-table 
                                            :headers="headersDashboard"
                                            :items="DetailsDashboard"                            
                                            :search="search"                        
                                            class="elevation-1"
                                            >
                                            <template v-slot:top>
                                                    <v-toolbar flat color="white"> 
                                                    <v-toolbar-title>You can search by any character</v-toolbar-title> 
                                                        <v-divider
                                                            class="mx-4"
                                                            inset
                                                            vertical
                                                        ></v-divider>   
                                                        <v-text-field class="text-xs-center" 
                                                          v-model="search" append-icon="search"
                                                         label="Search" single-line hide-details></v-text-field>              
                                                    </v-toolbar>                                            
                                            </template>
                                            
                                                <template v-slot:body="{ items }">
                                                    <tbody>
                                                        <tr v-for="item in items" :key="item.ID">

                                                        <td class="text-xs-right">
                                                            <div >
                                                                <div >   
                                                                    <v-icon small class="mr-2" 
                                                                    @click="collectionsShow(item)">
                                                                            collections
                                                                        </v-icon>   
                                                                    <v-icon small v-if="item.signList.length > 0"
                                                                    @click="signaturesShow(item)"
                                                                    class="mr-2" >
                                                                        person
                                                                    </v-icon>                                                                                                                               
                                                                </div>
                                                            </div>
                                                        </td>    
                                                                                        
                                                        <td class="text-xs-right">
                                                            <v-chip color="orange" dark>{{item.statusName}}</v-chip>                                                                                                          
                                                        </td>
                                                         <td class="text-xs-right">{{item.platform}} </td> 
                                                         <td class="text-xs-right">{{item.model}} </td> 
                                                         <td class="text-xs-right">{{item.lob}} </td> 
                                                         <td class="text-xs-right">{{item.area}} </td> 
                                                         <td class="text-xs-right">{{item.line_type}} </td> 
                                                         <td class="text-xs-right">{{item.station_no}} </td>
                                                         <td class="text-xs-right">{{item.creator}} </td>                                                        
                                                         <td class="text-xs-right">                                                        
                                                            <div v-if="item.create_dt != null">
                                                                <span class="blue--text">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}}</span>                                    
                                                            </div>
                                                            <div v-else>
                                                            <span class="red--text">-----</span>
                                                            </div>                                
                                                        </td>                                                          
                                                         <td class="text-xs-right">{{item.updater}} </td>                                                         
                                                         <td class="text-xs-right">                                                        
                                                            <div v-if="item.update_dt != null">
                                                                <span class="blue--text">{{moment(item.update_dt).format('MM/DD/YYYY HH:mm')}}</span>                                    
                                                            </div>
                                                            <div v-else>
                                                            <span class="red--text">-----</span>
                                                            </div>                                
                                                        </td> 
                                                                            
                                                        </tr>
                                                    </tbody>
                                                    
                                                </template>
                                                    
                                                <template v-slot:no-data>                                
                                                <v-alert :value="true" color="error" icon="warning">
                                                        Sorry, nothing to display here :(
                                                    </v-alert>
                                                </template>
                                                
                                        </v-data-table>
                                       
                                       
                                        </v-flex>
                                                <template>                                              
                                                
                                                </template>
                                        </v-layout>             
                                    </v-container> 


                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>                                                            
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-row>

                     <v-row>
                        <v-dialog v-model="dialogShowImages" persistent max-width="1000px"   >
                            <v-card>
                            <v-toolbar
                                color="indigo"
                                dark
                                >                              
                                <v-toolbar-title>{{carrouselTitle}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon @click="collectionsHide">close</v-icon>
                                </v-btn>
                                </v-toolbar>                                                
                                <v-card-text>

                                    <v-container  grid-list-sm class="pa-4 white" >              
                                        <v-layout row wrap>                
                                        
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                                <v-card
                                                elevation="24"
                                                max-width="85%"
                                                class="mx-auto"
                                            >
                                                <v-system-bar lights-out></v-system-bar>

                                            <v-carousel
                                                cycle
                                                height="100%"
                                                
                                                show-arrows-on-hover
                                                :cycle="cycle"
                                                v-model="model"
                                            >                                                                       

                                                <v-carousel-item
                                                v-for="(item,i) in itemsSOP"
                                                :key="i"
                                                >                                                                       
                                                    <v-row
                                                    class="fill-height"
                                                    align="center"
                                                    justify="center"
                                                    >                                                                        
                                                    <v-img
                                                        :src="item.img_path"
                                                        height="100%"
                                                        class="grey darken-4"
                                                        ></v-img>
                                                    
                                                    </v-row>                                                                        
                                                </v-carousel-item> 
                                            </v-carousel>
                                            </v-card>

                                        </v-flex>
                                                <template>                                              
                                                
                                                </template>
                                        </v-layout>             
                                    </v-container> 


                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>                                                            
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-row>

                    <v-row>
                        <v-dialog v-model="dialogShowSignatures" persistent max-width="1200px"   >
                            <v-card>
                            <v-toolbar
                                color="indigo"
                                dark
                                >                              
                                <v-toolbar-title>{{signaturesTitle}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon @click="signaturesHide">close</v-icon>
                                </v-btn>
                                </v-toolbar>                                                
                                <v-card-text>

                                    <v-container  grid-list-sm class="pa-4 white" >              
                                        <v-layout row wrap>                
                                        
                                        <v-flex xs12 sm12 md12 lg12 xl12>
                                          
                                            <!--DataTable here-->
                                         <v-data-table 
                                            :headers="headersSignatures"
                                            :items="DetailsSignatures"                            
                                            hide-default-footer                          
                                            class="elevation-1"
                                            >
                                            <template v-slot:top>
                                                    <v-toolbar flat color="white"> 
                                                    <v-toolbar-title>Signatures</v-toolbar-title> 
                                                        <v-divider
                                                            class="mx-4"
                                                            inset
                                                            vertical
                                                        ></v-divider>                 
                                                    </v-toolbar>                                            
                                            </template>
                                            
                                                <template v-slot:body="{ items }">
                                                    <tbody>
                                                        <tr v-for="item in items" :key="item.ID">
                                                                        

                                                            
                                                            <td class="text-xs-right">{{item.send_sequence}} </td>                                                            
                                                            <td class="text-xs-right">                                                        
                                                                <div v-if="item.send_date != null">
                                                                    <span class="blue--text">{{moment(item.send_date).format('MM/DD/YYYY HH:mm')}}</span>                                    
                                                                </div>
                                                                <div v-else>
                                                                <span class="red--text">-----</span>
                                                                </div>                                
                                                            </td>                                                                     
                                                            <td class="text-xs-right">
                                                                <div v-if="item.contactType == 'Validator'">
                                                                    <v-chip color="purple" dark>{{item.contactType}}</v-chip>                                                                                    
                                                                </div>
                                                                <div v-if="item.contactType == 'Approver'">                                                   
                                                                    <v-chip color="orange" dark>{{item.contactType}}</v-chip>                                  
                                                                </div>                                              
                                                            </td>
                                                            
                                                            <td class="text-xs-right">{{item.contactname}} </td> 
                                                            <td class="text-xs-right">                                                
                                                                <span class="blue--text"> {{item.email}} </span>                                          
                                                            </td>                                                            
                                                            <td class="text-xs-right">                                                        
                                                                <div v-if="item.is_sign">
                                                                    <span class="blue--text">Yes</span>                                    
                                                                </div>
                                                                <div v-else>
                                                                <span class="red--text">-----</span>
                                                                </div>                                
                                                            </td>   
                                                           
                                                            <td class="text-xs-right">                                                        
                                                                <div v-if="item.sign_dt != null">
                                                                    <span class="blue--text">{{moment(item.sign_dt).format('MM/DD/YYYY HH:mm')}}</span>                                    
                                                                </div>
                                                                <div v-else>
                                                                <span class="red--text">-----</span>
                                                                </div>                                
                                                            </td>    
                                                            <td class="text-xs-right">{{item.comments}} </td>                                                            
                                                            <!--<td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td> -->                          
                                                        </tr>
                                                    </tbody>
                                                    
                                                </template>
                                                    
                                                <template v-slot:no-data>                                
                                                <v-alert :value="true" color="error" icon="warning">
                                                        Sorry, nothing to display here :(
                                                    </v-alert>
                                                </template>
                                                
                                        </v-data-table>
                                       
                                       
                                        </v-flex>
                                                <template>                                              
                                                
                                                </template>
                                        </v-layout>             
                                    </v-container> 


                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>                                                            
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-row>
 
   
</v-container>


 
</v-layout>
        
  
</template>

<script>    
    import axios from 'axios'; 
    import moment from 'moment'; 
   
    export default{
        components: {
                     
        },       
        data (){
            return {
                  moment:moment,                
                  partnoAlt:[],                  
                  dialog: false,
                  dialogLoading: false,
                  dialogShowDashboardDetail: false,
                  headersDashboard: [
                        { text: 'Actions', value: 'action', sortable: false },                           
                        { text: 'Status', value: 'statusName', sortable: false },                     
                        { text: 'Platform', value: 'platform', sortable: false },
                        { text: 'Model', value: 'model', sortable: false },                                               
                        { text: 'Lob', value: 'lob', sortable: false },
                        { text: 'Area', value: 'area', sortable: false },                        
                        { text: 'Line type', value: 'line_type', sortable: false },
                        { text: 'Station no', value: 'station_no', sortable: false },                                               
                        { text: 'Creator', value: 'creator', sortable: false },
                        { text: 'Create dt', value: 'create_dt', sortable: false },
                        { text: 'Updater', value: 'updater', sortable: false },                                               
                        { text: 'Update dt', value: 'update_dt', sortable: false }                      
                    ],
                     headersDetail: [
                        { text: 'Delete', value: 'delete', sortable: false },       
                        { text: 'Send email', value: 'sequence', sortable: false },                 
                        { text: 'Contact type', value: 'contactType', sortable: false },
                        { text: 'Contact Badgeid', value: 'badgeid', sortable: false },
                        { text: 'Contact name', value: 'contactName', sortable: false },                                               
                        { text: 'Email', value: 'email', sortable: false }                      
                    ],
                      headersSignatures: [                              
                        { text: '#Step', value: 'send_sequence', sortable: false },                 
                        { text: 'Send date', value: 'send_date', sortable: false }, 
                        { text: 'Contact type', value: 'contactType', sortable: false },
                        { text: 'Name', value: 'contactname', sortable: false },
                        { text: 'Email', value: 'email', sortable: false },                                               
                        { text: 'Signature', value: 'is_sign', sortable: false },
                        { text: 'Signature date', value: 'sign_dt', sortable: false },
                        { text: 'Comments', value: 'comments', sortable: false }                         
                    ],

                    DetailsContact: [
                        ],
                    //moment: moment, // Set to whatever
                    //privileges: false,
                    search: '',
                    desserts: [],
                    editedIndex: -1,

                    dialogShowSignatures:false,
                    dialogShowImages:false,
                    model: 0,
                    cycle: false,
                    itemsSOP: [                       
                        ],
                    
                    signaturesTitle:'',
                    carrouselTitle:'',
                    title:'',
                    dashboardItems: [                        
                    ],                    
                    DetailsDashboard:[],
                    dashboardDevelopment1:[],
                    dashboardValidating2:[],
                    dashboardApproving3:[],
                    dashboardApproved4:[],
                    dashboardPromoted5:[],
                    dashboardRejected6:[],
                    dashboardCanceled7:[],
                    
                    DetailsSignatures:[],

                    verNuevo:0,
                    errorContact: null,

                    frmFlowname: '',
                    frmContactType: 'Validator',                    
                    contactType: ['Validator','Approver'],
                    frmContactBadgeid: '',

                    id: '', 
                    part_number: '', 
                    part_number_alt: '', 
                    create_dt: '', 


                    verContactos:0,
                    headersContact:[
                        { text: 'Select', value: 'select', sortable: false },                        
                        { text: 'Badgeid', value: 'badgeid', sortable: false },
                        { text: 'Name', value: 'contactname' },
                        { text: 'Email', value: 'email', sortable: false }                      
                    ],
                    contactos:[],
                    texto:'',                
                   
                    valida:0,
                    validaMensaje:[],

                    adModal: 0,
                    adAccion: 0, 
                    adName: '',
                    adId: '',  

                    flowname: ''
                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Contact' : 'Edit Contact'
            },
                          
        },

        watch: {
            dialog (val) {
            val || this.close()
            } ,
             dialogLoading (val)  {
                if (!val) return
            }          
        },

        created () {
            this.initialize();
            this.listDashboard();
            //this.havePriviges();     
        },

         methods: { 
            
            complete (index) {
                this.list[index] = !this.list[index]
            },
            showContactList(){
                this.verContactos = 1;
                //console.log(this.verContactos);
            },
            hideContactList(){
                this.verContactos = 0;
            },
            showNew(){
                this.verNuevo = 1;                
                //console.log("show New");
            },
            hideNew(){
                this.verNuevo = 0;
                this.clean();               
            },
            showDashboardDetail(id){
                this.dialogShowDashboardDetail = true;                
                switch (id) {
                    case 1:
                        this.title = 'Development';
                        this.DetailsDashboard = this.dashboardDevelopment1;
                        break;
                    case 2:
                         this.title = 'Validating';
                         this.DetailsDashboard = this.dashboardValidating2;
                        break;
                    case 3:
                        this.title = 'Approving';
                        this.DetailsDashboard = this.dashboardApproving3;
                        break;
                    case 4:
                        this.title = 'Approved';
                        this.DetailsDashboard = this.dashboardApproved4;
                        break;
                    case 5:
                         this.title = 'Promoted';
                         this.DetailsDashboard = this.dashboardPromoted5;
                        break;
                    case 6:
                        this.title = 'Rejected';
                        this.DetailsDashboard = this.dashboardRejected6;
                        break;
                    case 7:
                         this.title = 'Canceled';
                         this.DetailsDashboard = this.dashboardCanceled7;
                        break;
                    default:
                        console.log("default case");
                }

            },
            hideDashboardDetail(){
                this.dialogShowDashboardDetail = false;;
            },
             collectionsShow(item){
                this.dialogShowImages = true;                
                this.itemsSOP = item.imagesPath;
                this.model = 0; 

                this.carrouselTitle = 'Station: ' + item.station_no 
                    + ' [ ' + item.platform 
                    + ' / ' + item.model 
                    + ' / ' + item.lob 
                    + ' / ' + item.area 
                    + ' / ' + item.line_type + ' ]';                

            },
            collectionsHide(){
                this.dialogShowImages = false;
            },
            signaturesShow(item){
                this.dialogShowSignatures = true;
                this.DetailsSignatures = item.signList;

                this.signaturesTitle =  'Station: ' + item.station_no 
                    + ' [ ' + item.platform 
                    + ' / ' + item.model 
                    + ' / ' + item.lob 
                    + ' / ' + item.area 
                    + ' / ' + item.line_type + ' ]';  
                                
            },
            signaturesHide(){
                this.dialogShowSignatures = false;
            },
            
             exitApp(){
                this.$store.dispatch("exit");
            }, 
            findContact(){  
                console.log('Buscar contacto');
                let me=this;

                me.errorContact = null;

                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_contact/BuscarContact/' + me.frmContactBadgeid;               
                axios.get(url,configuration).then(function(response){
                    //console.log(response);
                    me.addContact(response.data);
                    me.frmContactBadgeid = '';
                    //me.partnoAlt = response.data;
                }).catch(function(error){
                    console.log(error);

                    me.errorContact = 'Contact no exist';
                })
            }, 
            listContact(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_contact/ListContact/' + me.texto;               
                axios.get(url,configuration).then(function(response){                   
                    me.contactos = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            addContact(data = []){
                this.errorContact = null;
                if (this.findDuplicate(data['id_contact'])){
                    this.errorContact = "Contact has already been added";
                }else{

                    var sendSequence = 0;
                    sendSequence  = this.DetailsContact.length +1;

                    this.DetailsContact.push(
                        {
                            id: data['id_contact']
                            ,sequence: sendSequence
                            ,contactType: this.frmContactType
                            ,badgeid: data['badgeid']
                            ,contactName: data['contactname']
                            ,email: data['email']
                        }
                    );
                }
            }, 
            findDuplicate(id){
                var sw = 0;
                for (var i=0; i < this.DetailsContact.length; i++){
                    if (this.DetailsContact[i].id == id){
                        sw = 1;
                    }
                }
                return sw;
            },
            deleteContact(arr, item){
                var sendSequence = 0;

                var i = arr.indexOf(item);
                if (i !== -1){
                    arr.splice(i,1);
                }

                for (var i=0; i < this.DetailsContact.length; i++){
                    sendSequence++
                    this.DetailsContact[i].sequence = sendSequence;

                }
            },          
            listWorkflow(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_s_workflow_master/List';               
                axios.get(url,configuration).then(function(response){
                    //console.log(response);
                    me.partnoAlt = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },

             listDashboard(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_sop_d_document_master/DashboardList';               
                axios.get(url,configuration).then(function(response){
                   
                    me.dashboardItems = response.data;                   
                    
                    me.dashboardDevelopment1 = me.dashboardItems.filter(c => c.id_status === 1);
                    me.dashboardValidating2 = me.dashboardItems.filter(c => c.id_status === 2);
                    me.dashboardApproving3 = me.dashboardItems.filter(c => c.id_status === 3);
                    me.dashboardApproved4 = me.dashboardItems.filter(c => c.id_status === 4);
                    me.dashboardPromoted5 = me.dashboardItems.filter(c => c.id_status === 5);
                    me.dashboardRejected6 = me.dashboardItems.filter(c => c.id_status === 6);
                    me.dashboardCanceled7 = me.dashboardItems.filter(c => c.id_status === 7);

                }).catch(function(error){
                    console.log(error);
                })
            },
            
            initialize () {                            
            },
            
            editItem (item) {
                                               
                this.id= item.id_flow;  
                this.frmFlowname= item.flowname; 
                this.DetailsContact = item.details;
                this.showNew();
                //this.email= item.email; 
                //this.condition= item.condition;
                      
                this.editedIndex=1;
                //this.dialog = true
            },

            activeDesactiveItem (accion, item) {
                this.adModal= 1;
                this.adName = item.flowname;
                this.adId = item.id_flow;

                if (accion == 1){
                   this.adAccion = 1;
                } else if (accion == 2){
                    this.adAccion = 2;
                } else{
                   this.adModal= 0;
                }                
            },

            activateDesactivateClose(){
                this.adModal = 0;
            },

            activate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_workflow_master/Activate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listWorkflow();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },
            deactivate(){
                let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/dell_sop_s_workflow_master/Desactivate/' + this.adId,{},configuration).then(function(response){
                        me.adModal =0;
                        me.adAccion = 0;
                        me.adName = "";
                        me.adId = "";                       
                        me.listWorkflow();                        
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);
            },

            close () {
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
            clean() {               

                this.id= ""; 

                this.frmFlowname = "";
                this.frmContactBadgeid = "";
                this.DetailsContact =[];

                this.contactname= "";
                this.email= "";
                this.condition= ""; 
                  
               
                this.editedIndex=-1;

                this.valida= 0;
                this.validaMensaje= [];

            },           
          
            save () {               

                    if ( this.editedIndex < 0)    
                    {    
                        //Code for Save                   
                        if (this.validar()){
                            return;
                        }

                        let me=this; 
                        let header={
                            "x-token": this.$store.state.token,
                            "Authorization": "Bearer " + this.$store.state.token                       
                            };   
                        //let header={"Authorization": "Bearer " + this.$store.state.token};
                        let configuration = {headers : header };
                        this.dialogLoading = true;         
                        axios.post('api/dell_sop_s_workflow_master/CreateWorkFlow',{                                                   
                                'flowname': me.frmFlowname,
                                'Details': me.DetailsContact                                 
                        },configuration).then(function(response){
                            //console.log('Save');
                            me.hideNew();
                            me.listWorkflow();
                            me.clean();
                            if (response.data.msg == 'Token no valid')
                            {
                                me.exitApp();
                            }
                        }).catch(function(error){                     
                        console.log(error);
                        }).finally(() => this.dialogLoading  = false,
                            this.validaMensaje.push('Workflow is already registered.')
                        );  
                    }
                    if ( this.editedIndex == 1)    
                    { 
                        //Code for Update                   
                        if (this.validar()){
                            return;
                        }

                        let me=this; 
                        let header={
                            "x-token": this.$store.state.token,
                            "Authorization": "Bearer " + this.$store.state.token                       
                            };   
                        //let header={"Authorization": "Bearer " + this.$store.state.token};
                        let configuration = {headers : header };
                        this.dialogLoading = true;         
                        axios.post('api/dell_sop_s_workflow_master/UpdateWorkflow',{ 
                                'id_flow' :  me.id,                                                
                                'flowname': me.frmFlowname,
                                'Details': me.DetailsContact                                 
                        },configuration).then(function(response){
                            //console.log('Save');
                            me.hideNew();
                            me.listWorkflow();
                            me.clean();
                            if (response.data.msg == 'Token no valid')
                            {
                                me.exitApp();
                            }
                        }).catch(function(error){                     
                        console.log(error);
                        }).finally(() => this.dialogLoading  = false,
                            this.validaMensaje.push('Workflow is already registered.')
                        );  
                        
                    }
                              
            },
           
            validar() {
                 this.valida=0;
                 this.validaMensaje=[];
                 
                 if (!this.frmFlowname){
                     this.validaMensaje.push('Input flow name.');
                 }   
                 if (this.DetailsContact.length <= 0){
                     this.validaMensaje.push('Please add contacts to workflow.');
                 }
                  
                 if (this.validaMensaje.length){
                    this.valida=1;                    
                }                                             
                 return this.valida;
            },
        },
    }
</script>

